import React from "react";
import { useNavigate } from "react-router-dom";
import {
  getColorCard,
  getColorBody,
  getColorText,
  getIconHuay,
} from "../../helper/Colorhuaycard";
import CountdownDevil from "../Countdown";

const LotteryTypeCard = (props) => {
  const navigate = useNavigate();

  const renderDateColumn = (data, type, row) => {
    let d = new Date(data);
    return (
      d.getDate().toString().padStart(2, "0") +
      "/" +
      (d.getMonth() + 1).toString().padStart(2, "0") +
      "/" +
      d.getFullYear() +
      " " +
      d.getHours().toString().padStart(2, "0") +
      ":" +
      d.getMinutes().toString().padStart(2, "0")
    );
  };

  const onClick = (lotteryId, roundId, name, closeSale) => {
    if (
      name === "จับยี่กี" ||
      name === "จับยี่กี 5G" ||
      name === "จับยี่กี 12 ราศี"
    ) {
      if (!localStorage.getItem(lotteryId)) {
        localStorage.setItem(lotteryId, JSON.stringify([]));
        localStorage.setItem(`check_${lotteryId}`, JSON.stringify([]));
      }
      localStorage.setItem("lotteryName", name);
      localStorage.setItem("lotteryId", lotteryId);
      navigate(`/chooseRound`);
    } else if (name === "หวย JACKPOT 6 ตัว" || name === "หวยลาว SUPER") {
      if (!localStorage.getItem(lotteryId)) {
        localStorage.setItem(lotteryId, JSON.stringify([]));
        localStorage.setItem(`check_${lotteryId}`, JSON.stringify([]));
      }
      localStorage.setItem("lotteryName", name);
      localStorage.setItem("lotteryId", lotteryId);
      localStorage.setItem("roundId", roundId);
      // console.log("roundId :", roundId )
      navigate(`/buylottery`);
    } else {
      if (!localStorage.getItem(lotteryId)) {
        localStorage.setItem(lotteryId, JSON.stringify([]));
        localStorage.setItem(`check_${lotteryId}`, JSON.stringify([]));
      }
      localStorage.setItem("lotteryId", lotteryId);
      localStorage.setItem("roundId", roundId);
      localStorage.setItem("closeRoundDatetime", closeSale);
      localStorage.setItem("lotteryName", name);

      if (localStorage.getItem("Round")) {
        localStorage.removeItem("Round");
      }
      navigate(`/playlottery`);
    }
  };

  return (
    <button
      className={`w-full -z-0 h-auto ${props.roundId || `filter grayscale`}`}
      disabled={props.roundId ? false : true}
      onClick={() =>
        onClick(
          props.lotteryId,
          props.roundId,
          props.name,
          props.closeSale
        )
      }
    >
      <div
        className={`text-white rounded p-0.5 ${getColorCard(
          props.name.replace(" SUPER", "")
        )}`}
      >
        <div className="grid grid-cols-3">
          <div className="col-span-3 text-center">
            <p className="w-auto text-sm md:text-base pb-1 pt-0.5">
              {props.roundId
                ? props.group === "Yeekee"
                  ? props.name === "จับยี่กี" || props.name === "จับยี่กี SUPER"
                    ? `เปิดวันละ 90 รอบ`
                    : `เปิดวันละ 288 รอบ`
                  : `ปิดรับแทง ${renderDateColumn(props.closeSale)}`
                : `เปิดรับแทง ${props.openRoundSaleHour}:${props.openRoundSaleMinute}`}
            </p>
            <div
              className={`rounded-bl rounded-br w-full ${getColorBody(
                props.name.replace(" SUPER", "")
              )}`}
            >
              <div className="grid grid-cols-12 ">
                <div className="col-span-7 flex text-left px-1">
                  <img
                    alt={props.name}
                    src={getIconHuay(props.name.replace(" SUPER", ""))}
                    width={52}
                    height={52}
                  />
                  <span
                    className={`pl-1 pt-3.5 text-sm font-bold ${getColorText(
                      props.name.replace(" SUPER", "")
                    )}`}
                  >
                    {props.name}
                  </span>
                </div>
                <div className="col-span-5 text-center px-3 pt-2.5">
                  <div className="bg-white rounded pb-1 text-[#00A36C]">
                    <span className="pr-1 text-sm">
                      {/* {getIconFontawesome("alarmClockSolid", "sm")} */}
                    </span>
                    {props.closeSale ? (
                      <CountdownDevil
                        group={props.group}
                        closeSale={props.closeSale}
                      />
                    ) : (
                      <span className="text-xs font-bold">ปิดรับแทง</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
};

export default LotteryTypeCard;
